if (!customElements.get('banner-slider')) {
  customElements.define(
    'banner-slider',
    class BannerSlider extends HTMLElement {
      /* Tempo sem interacao antes de o autoplay voltar sozinho. */
      static get RESUME_DELAY() {
        return 8000;
      }

      connectedCallback() {
        this.track = this.querySelector('.banner__slides');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('.banner__dot'));
        if (this.slides.length < 2) return;

        this.current = 0;
        this.delay = parseInt(this.dataset.autoplay, 10) || 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot, i) =>
          dot.addEventListener('click', () => {
            this.goTo(i);
            this.pauseAutoplay();
          })
        );

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              /* isIntersecting continua true no slide que esta saindo — comparar o ratio
                 evita que o slide anterior sobrescreva o indice durante a transicao. */
              if (entry.intersectionRatio < 0.6) return;
              this.current = this.slides.indexOf(entry.target);
              this.syncDots();
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        if (this.delay > 0 && !this.reducedMotion) {
          this.onPointerDown = () => this.pauseAutoplay();
          this.onWheel = (event) => {
            /* O hero ocupa o topo do viewport, entao a rolagem vertical da pagina
               tambem passa por aqui: so pausar quando a intencao e horizontal. */
            if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
            this.pauseAutoplay();
          };
          this.onVisibility = () => {
            if (document.hidden) {
              this.stopAutoplay();
            } else {
              this.startAutoplay();
            }
          };

          this.track.addEventListener('pointerdown', this.onPointerDown, { passive: true });
          this.track.addEventListener('wheel', this.onWheel, { passive: true });
          document.addEventListener('visibilitychange', this.onVisibility);
          this.startAutoplay();
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.resumeTimer) {
          clearTimeout(this.resumeTimer);
          this.resumeTimer = null;
        }
        if (this.observer) this.observer.disconnect();
        if (this.onPointerDown) this.track.removeEventListener('pointerdown', this.onPointerDown);
        if (this.onWheel) this.track.removeEventListener('wheel', this.onWheel);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      startAutoplay() {
        if (this.timer || this.delay <= 0 || this.reducedMotion) return;
        /* Aba oculta nao anima scroll suave — o visibilitychange religa ao voltar. */
        if (document.hidden) return;
        if (this.resumeTimer) {
          clearTimeout(this.resumeTimer);
          this.resumeTimer = null;
        }
        this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), this.delay);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      /* Pausa temporaria por interacao — volta sozinha depois de RESUME_DELAY. */
      pauseAutoplay() {
        if (this.delay <= 0 || this.reducedMotion) return;
        this.stopAutoplay();
        if (this.resumeTimer) clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => {
          this.resumeTimer = null;
          this.startAutoplay();
        }, this.constructor.RESUME_DELAY);
      }

      goTo(index) {
        this.current = index;
        this.syncDots();
        this.track.scrollTo({
          left: this.track.clientWidth * index,
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
      }

      syncDots() {
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.current);
          dot.setAttribute('aria-current', i === this.current ? 'true' : 'false');
        });
      }
    }
  );
}
